import { EmployeeStatus } from "../../generated/graphql";

export const statuses = [
  { value: EmployeeStatus.Active, label: "有効" },
  { value: EmployeeStatus.Inactive, label: "無効" },
];
